var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66279 6.89869C7.48787 6.89869 8.15675 6.22981 8.15675 5.40472C8.15675 4.57964 7.48787 3.91076 6.66279 3.91076C5.8377 3.91076 5.16882 4.57964 5.16882 5.40472C5.16882 6.22981 5.8377 6.89869 6.66279 6.89869Z",
    fill: "#68B5C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7682 16.9905H0.554647C0.250194 16.9905 0 16.7403 0 16.4358C0 16.1314 0.250194 15.8812 0.554647 15.8812H12.7682C13.0726 15.8812 13.3228 16.1314 13.3228 16.4358C13.3228 16.7426 13.0726 16.9905 12.7682 16.9905Z",
    fill: "#68B5C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 4.38042C11.5939 2.27521 9.92523 0.547656 7.8271 0.113398C7.43061 0.0307942 7.04356 -0.0022426 6.66123 0.000117501C6.28125 0.000117501 5.89185 0.0331543 5.49535 0.113398C3.39958 0.547656 1.7286 2.27521 1.33683 4.38042C1.01821 6.10093 1.69084 7.56425 2.51215 8.85995C3.65916 10.6725 6.19393 14.5643 6.19393 14.5643C6.29778 14.7437 6.4795 14.831 6.66123 14.8286C6.84296 14.831 7.02468 14.7437 7.12852 14.5643C7.12852 14.5643 9.66094 10.6701 10.8103 8.85995C11.6316 7.56425 12.3042 6.09857 11.9856 4.38042ZM6.67068 8.99207C6.66832 8.99207 6.66595 8.99207 6.66359 8.99207C6.66123 8.99207 6.65886 8.99207 6.6565 8.99207C4.67402 8.99207 3.06916 7.38485 3.06916 5.40473C3.06916 3.4246 4.67638 1.81738 6.6565 1.81738C6.65886 1.81738 6.66123 1.81738 6.66359 1.81738C6.66595 1.81738 6.66832 1.81738 6.67068 1.81738C8.65316 1.81738 10.258 3.4246 10.258 5.40473C10.258 7.38485 8.6508 8.99207 6.67068 8.99207Z",
    fill: "#68B5C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.1a2b6f633610db3457d3be22da0a2dda.svg";
export { ForwardRef as ReactComponent };